// AI-GEN-BEGIN - FYS/通用：列表下载列 HTML（相对路径 + 登录域）
/**
 * 根据后台返回的相对下载路径拼接可点击「下载」链接 HTML。
 * @param relativePath 列表接口返回的相对路径（如 /admin/fys/upload/downloadOriginal?...），空则无入口
 * @param hostname 当前页面 hostname，localhost 时指向测试域以携带联调 cookie
 * @param linkText 链接文案，默认「下载」
 */
export function buildAdminDownloadLinkHtml(
  relativePath: string | null | undefined,
  hostname: string,
  linkText = '下载',
): string {
  if (!relativePath) {
    return '-'
  }
  const base = hostname === 'localhost'
    ? 'https://mis.test.lecoosys.com'
    : `https://${hostname}`
  return `<a class="el-link el-link--primary is-underline" href="${base}${relativePath}" target="_blank">${linkText}</a>`
}
// AI-GEN-END
